import ContentLoader from 'react-content-loader';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const Badge = ({ width, height, speed, ...props }) => {
  const { darkMode } = useSelector((state) => state.general);
  const isDarkMode = darkMode;
  return (
    <ContentLoader
      speed={speed}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor={isDarkMode ? '#222327' : '#f8f8f8'}
      foregroundColor={isDarkMode ? '#2f3136' : '#eeeeee'}
      {...props}
    >
      <rect width={width} height={height} rx={10} />
    </ContentLoader>
  )
}

Badge.defaultProps = {
  width: 27,
  height: 20,
  speed: 1,
}

Badge.propTypes = {
  speed: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default Badge;
